export const tempImageFormat = (link) => {
    const splitArray = link?.split('/');

    const TEMP_IMAGE_URL =
    'https://daotaoclbberich.s3.ap-southeast-1.amazonaws.com/fmdaotao/images';

    const result =  `${TEMP_IMAGE_URL}/${splitArray?.at(-1)}`;

    return result;
}